import React from "react";

/**
 * "Powered by smScope" footer, shown on every screen (inside AppLayout and
 * on the standalone Login page).
 *
 * Centered, discreet, always in the same visual position — regardless of
 * which client's deployment this is running in. Never overridden per-brand.
 */
export default function PoweredBySmScope({ className = "" }) {
  return (
    <div
      className={`w-full flex items-center justify-center gap-2 py-4 border-t border-gray-100 bg-white ${className}`}
      data-testid="powered-by-smscope"
    >
      <span className="text-[10px] uppercase tracking-[0.2em] text-gray-400 font-mono">
        Powered by
      </span>
      <img
        src="/branding/smscope-logo.png"
        alt="smScope"
        className="h-4 w-auto"
      />
    </div>
  );
}
